export default {
    status_no: '404',
    name: 'Not Found',
    message: 'This page does not exist',
}
